"use client";
import { getSize } from "../../core/utils/get-size/get-size.mjs";
import { createVarsResolver } from "../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { useStyles } from "../../core/styles-api/use-styles/use-styles.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { Box } from "../../core/Box/Box.mjs";
import Container_module_default from "./Container.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Container/Container.tsx
const defaultProps = { strategy: "block" };
const varsResolver = createVarsResolver((_, { size, fluid }) => ({ root: { "--container-size": fluid ? void 0 : getSize(size, "container-size") } }));
const Container = factory((_props) => {
	const props = useProps("Container", defaultProps, _props);
	const { classNames, className, style, styles, unstyled, vars, fluid, mod, attributes, strategy, ...others } = props;
	const getStyles = useStyles({
		name: "Container",
		classes: Container_module_default,
		props,
		className,
		style,
		classNames,
		styles,
		unstyled,
		attributes,
		vars,
		varsResolver
	});
	return /* @__PURE__ */ jsx(Box, {
		mod: [{
			fluid,
			strategy
		}, mod],
		...getStyles("root"),
		...others
	});
});
Container.classes = Container_module_default;
Container.varsResolver = varsResolver;
Container.displayName = "@mantine/core/Container";
//#endregion
export { Container };

//# sourceMappingURL=Container.mjs.map